<template>
  <div container>
    <div class="header-inner">
      <div class="header-title">
        <h2>{{title}}</h2>
      </div>
      <div class="selections">
        <div class="selection-group">
          <span>Group:</span>
          <a
            href="javascript:void(0)"
            class="selection"
            @click.stop="$emit('setActiveTab','group')"
          >
            {{selected.groupName}}
          </a>
        </div>
        <div class="selection-group">
          <span>Subgroup:</span>
          <a
            href="javascript:void(0)"
            class="selection"
            @click.stop="$emit('setActiveTab','subGroup')"
          >
            {{selected.subGroupName}}
          </a>
        </div>
      </div>
      <div class="clear">
        <a
          v-if="hasSelection"
          @click.stop="clearGroupSelection"
          href="javascript:void(0)"
        >
          Clear
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import groupSelection from '@mixins/groupSelection'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    mixins: [
      groupSelection
    ],
    props: ['title'],
    methods: {
      ...mapActions(
        'portalContext',
        {
          clearPortalContext: 'CLEAR_PORTAL_CONTEXT'
        },
        'groupSelector',
        {
          clearGroupSelection: 'CLEAR_ALL'
        }
      )
    },
    computed: {
      ...mapGetters(
        'portalContext',
        [
          'portalContextNames',
          'portalContextSelected',
          'groupSelected'
        ],
        'groupSelector',
        [
          'selected',
          'hasSelection'
        ]
      )
    }
  }
</script>
